export const accessObjectViaString = (object, access) => {
  if (!access || access.length < 1) {
    return object;
  }
  let attribute = object;
  access.split('.').forEach((el) => {
    const value = attribute[el];
    attribute = value || el;
  });
  return attribute;
};

export const calculateMenuHeight = (listSize,
  height = 48,
  gap = 75,
  maxItems = 4,
  maxSize = 275) => {
  if (listSize) {
    const size = (listSize > maxItems) ?
      maxSize :
      (height * listSize) + gap;
    return size < 120 ? 120 : size;
  }
  return 'auto';
};

export const componentExpandableSize = (listSize) => {
  const size = (listSize !== 'auto') ?
    listSize :
    'auto';
  return `${size}${isNaN(size) ? '' : 'px'}`;
};

export const copyObject = object => JSON.parse(JSON.stringify(object));

export const getClosestVueParent = (parent, cssClass) => {
  if (!parent || !parent.$el) {
    return false;
  }

  if (parent._uid === 0) { // eslint-disable-line no-underscore-dangle
    return false;
  }

  if (parent.$el.classList && parent.$el.classList.contains(cssClass)) {
    return parent;
  }

  return getClosestVueParent(parent.$parent, cssClass);
};

export const getClosestThemedParent = ($parent) => {
  if (!$parent || !$parent.$el || $parent._uid === 0) { // eslint-disable-line
    return false;
  }

  if ($parent.mdTheme || $parent.mdName) {
    return $parent;
  }

  return getClosestThemedParent($parent.$parent);
};

export const nestedObjectToArray = (nested) => {
  if (!nested) {
    return [];
  }
  return Object.keys(nested).map(el => nested[el]);
};

export const removeItem = (array, item) => {
  if (array && item && array.hasOwnProperty('length') && array.length) {
    const index = (isNaN(Number(item))) ?
      array.indexOf(item) :
      item;
    if (index !== -1) {
      array.splice(index, 1);
    }
  }
  return array;
};

export const convertCnpjString = cnpj => cnpj.replace(/[./-]/g, '');

export const convertToCnpj = cnpj => cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');

export const convertMoneytoFloat = (str) => {
  const money = String(str)
    .replace(/[^\d,-]/g, '')
    .replace(',', '.');
  return Number(money.length ? money : '0');
};

export const convertFloatToMoney = (str) => {
  const t1 = String(str).split('.');
  let t2 = '';
  if (t1[1]) {
    t2 = t1[1].length === 1 ? `${t1[1]}0` : t1[1];
  } else {
    t2 = '00';
  }
  return `${t1[0]}.${t2}`;
};

export const convertFloatToMoneyComma = (str) => {
  const t1 = String(str).split('.');
  let t2 = '';
  if (t1[1]) {
    t2 = t1[1].length === 1 ? `${t1[1]}0` : t1[1];
  } else {
    t2 = '00';
  }
  return `${t1[0]},${t2}`;
};

export const prepareResponseData = (response) => {
  if (response.data.hasOwnProperty('resposta')) {
    return response.data.resposta;
  }
  return response.data;
};

export const toColumnName = (n) => {
  const ordA = 'a'.charCodeAt(0);
  const ordZ = 'z'.charCodeAt(0);
  const len = (ordZ - ordA) + 1;

  let s = '';
  while (n >= 0) {
    s = String.fromCharCode((n % len) + ordA) + s;
    n = Math.floor(n / len) - 1;
  }
  return s;
};

export const toMoney = (n) => {
  if (n) {
    return `$ ${n.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')}`;
  }
  return '';
};

export const sumValues = (a, b) => (parseFloat(a) + parseFloat(b)).toFixed(2);

export const subtractValues = (a, b) => (parseFloat(a) - parseFloat(b)).toFixed(2);




// WEBPACK FOOTER //
// ./src/common/functions/helpers.js